import React from "react";
import "./LoadingLayout.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

function LoadingLayout() {
    return   <div className="loading-layout">
        <Header />
        <img id="spinner" src="/loading.svg"  alt="Loading..." />
        <div className="footer-wrapper">
            <Footer />
        </div>
    </div>
}

export default LoadingLayout;